import CustomTable from 'src/components/Table';

interface DataTableProps {
    dataGrid: any;
    setOpen: (open: boolean) => void;
    setDataItem: (item: any) => void;
    handleDeleteOpen: (item: any) => void;
}

function DataTable({
    dataGrid,
}: DataTableProps) {
    return (
        <CustomTable
            title="Units"
            alternateColor
            data={dataGrid}
            navigateAction={{
                handleDropdownChange(e, label) {
                    console.log(e.target.value, label);
                },
            }}
            columns={[
                {
                    label: 'No.',
                    field: 'no'
                },
                {
                    label: 'Serial No.',
                    field: 'serial_no'
                },
                {
                    label: 'Commodity',
                    field: 'commodity'
                },
                {
                    label: 'Container Number',
                    field: 'container_number'
                },
                {
                    label: 'Weight (Kg)',
                    field: 'weight'
                },
                {
                    label: 'Volume (CBM)',
                    field: 'volume'
                },
                {
                    label: 'Dangerous goods',
                    field: 'dangerous_goods'
                },
                {
                    label: 'Receiver Name',
                    field: 'receiver_name'
                },
                {
                    label: 'Remarks',
                    field: 'remarks'
                },
            ]}
        />

    );
}

export default DataTable;
